export interface IHomeTipSlideConfig {
  title: string;
  description: string;
  imageName: string;
}

export interface IHomeTipSlide extends IHomeTipSlideConfig {
  imageUrl: string;
}

export const STARTING_TIP_IMAGE_NAME = "Step 1 Get Started.png";
export const TERMS_OF_USE_FILE_NAME = "AskAmiTermsOfUse.pdf";

export const SLIDES: IHomeTipSlideConfig[] = [
  {
    title: "Be Specific",
    description:
      "Ask focused questions rather than broad ones. The more detailed your question, the more precise the response will be.",
    imageName: "Step 2 Be Specific.png",
  },
  {
    title: "Keep Topics Separate",
    description: "Start a new chat for each topic to keep responses clear and relevant.",
    imageName: "Step 3 Keep Topics Separate.png",
  },
  {
    title: "Provide Context",
    description: "Make sure that your questions have all of the necessary information to answer.",
    imageName: "Step 4 Provide Context.png",
  },
  {
    title: "Stay Within Service Scope",
    description:
      "Ask AMI pulls information from the Document Portal application. Make sure that you ask questions within the scope of the documents available to you.",
    imageName: "Step 5 Stay Within The Service Scope.png",
  },
  {
    title: "Verify Information",
    description: "Always verify the accuracy of Ask AMI's responses by checking the document(s) that it references.",
    imageName: "Step 6 Verify Information.png",
  },
];
